'use client';

import React from 'react';
import { DollarSign, CalendarCheck, Car, Headphones } from 'lucide-react';
import { useLocale } from '@/lib/i18n';

export function ValueProposition() {
  const { t } = useLocale();
  const benefits = [
    {
      icon: DollarSign,
      title: t('vp.1t'),
      desc: t('vp.1d'),
    },
    {
      icon: CalendarCheck,
      title: t('vp.2t'),
      desc: t('vp.2d'),
    },
    {
      icon: Car,
      title: t('vp.3t'),
      desc: t('vp.3d'),
    },
    {
      icon: Headphones,
      title: t('vp.4t'),
      desc: t('vp.4d'),
    },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-10 lg:py-14">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
        {benefits.map((benefit, idx) => {
          const Icon = benefit.icon;
          return (
            <div
              key={idx}
              className="flex items-start gap-4 p-2 transition-transform hover:-translate-y-0.5"
            >
              {/* Icon Container with Warm Orange Border Outline / Badge */}
              <div className="w-12 h-12 rounded-xl border border-amber-500/30 bg-amber-50/70 flex items-center justify-center shrink-0 shadow-xs">
                <Icon className="w-6 h-6 text-[var(--color-primary)]" />
              </div>
              <div>
                <h3 className="text-sm font-bold text-slate-900 tracking-tight mb-1">
                  {benefit.title}
                </h3>
                <p className="text-xs text-slate-500 leading-relaxed">
                  {benefit.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
